import type { BlockTable } from 'shared-types';

type LocaleData = BlockTable['locales'][string];

const defaultBlockData = {
  format: 'html' as const,
  layout: 'auto' as const
};

const translatable: LocaleData['translatable'] = {
  text: '<table><tbody><tr><td></td><td></td></tr><tr><td></td><td></td></tr></tbody></table>'
};
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  text: '{{ locales.translatable.text }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockTableData: BlockTable = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockTable['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
